// Tasks module shell. The implementation lives in WorkOrdersPage —
// passing `moduleKind="task"` switches it to the tasks permission
// family (`tasks:*`), the `/tasks` URL family, and the `api.tasks.*`
// client namespace. Keeping a single page implementation means
// list / detail / kanban / table / calendar / workload all stay in
// sync between the two modules with zero drift.
import { WorkOrdersPage } from '../work-orders/WorkOrdersPage'

export function TasksPage() {
  return <WorkOrdersPage moduleKind="task" />
}
